import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";

const CONSENT_KEY = "cookie_consent";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    setVisible(false);
  };

  const refuse = () => {
    localStorage.setItem(CONSENT_KEY, "refused");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[60] p-4 md:p-6">
      <div className="container mx-auto max-w-3xl">
        <div className="rounded-2xl border border-white/70 bg-white/90 p-5 shadow-lg backdrop-blur-xl">
          <p className="mb-4 text-sm leading-6 text-foreground/80">
            Ce site utilise des cookies strictement nécessaires au fonctionnement du service.
            Pour en savoir plus, consultez notre{" "}
            <a href="/politique-confidentialite" className="underline text-primary hover:text-primary/80">
              politique de confidentialité
            </a>.
          </p>
          <div className="flex items-center gap-3">
            <Button variant="premium" size="sm" className="rounded-full" onClick={accept}>
              Accepter
            </Button>
            <Button variant="outline" size="sm" className="rounded-full" onClick={refuse}>
              Refuser
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
